import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AdminPortal } from "@frontegg/react";
import { useState } from "react";
import LogoutIcon from "@mui/icons-material/LogoutOutlined";
import { Box, Divider, ListItemButton, ListSubheader, Stack } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import { styled } from "@mui/material/styles";
import { Avatar } from "@climatepartner/components";
import { generateInitials } from "@climatepartner/utils";
const sxStyles = {
    menuList: {
        width: "100%",
        maxWidth: 360,
        paddingBottom: 0,
    },
    subheader: {
        color: "#5B5B5B",
        lineHeight: "24px",
        padding: "2px 6px",
        fontWeight: 400,
    },
    listItemButton: {
        padding: 1,
        borderRadius: 16,
        "&:hover": {
            backgroundColor: "#F5F5F5",
        },
    },
    listItemLabel: {
        color: "#212121",
        fontWeight: 500,
    },
    divider: {
        borderColor: "#eee",
        my: 1,
    },
    logoutIcon: {
        ml: 1,
        fontSize: "inherit",
    },
};
const StyledMenu = styled((props) => (_jsx(Menu, { elevation: 0, anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
    }, transformOrigin: {
        vertical: "top",
        horizontal: "right",
    }, ...props })))(() => ({
    "& .MuiPaper-root": {
        borderRadius: 8,
        boxShadow: "0px 20px 60px 2px #003C911A",
        "& .MuiMenu-list": {
            padding: "12px",
        },
    },
}));
const AvatarSlot = ({ slots, header, actions }) => {
    const isAdminUser = (window.location.host === "app.climatepartner.com" && actions?.hasPermission("customer.organization.admin")) ??
        false;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    if (slots?.avatar) {
        return _jsx(_Fragment, { children: slots.avatar });
    }
    if (!header?.user && process.env.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.warn("AvatarSlot: Missing user data for avatar slot");
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (_jsxs("div", { children: [_jsx(IconButton, { id: "avatar-menu-button", "aria-controls": open ? "avatar-menu" : undefined, "aria-haspopup": "true", "aria-expanded": open ? "true" : undefined, onClick: handleClick, children: _jsx(Avatar, { children: generateInitials(header?.user?.name) }) }), actions && (_jsxs(StyledMenu, { id: "avatar-menu", MenuListProps: {
                    "aria-labelledby": "avatar-menu-button",
                }, anchorEl: anchorEl, open: open, onClose: handleClose, children: [isAdminUser && (_jsxs("div", { children: [_jsx(ListSubheader, { sx: sxStyles.subheader, component: "div", id: "nested-list-subheader", children: "Settings" }), _jsx(ListItemButton, { sx: sxStyles.listItemButton, onClick: () => {
                                    AdminPortal.show();
                                    handleClose();
                                }, children: _jsx(Box, { sx: sxStyles.listItemLabel, children: "Account profile" }) }), _jsx(Divider, { sx: sxStyles.divider })] })), _jsx(ListItemButton, { sx: sxStyles.listItemButton, onClick: () => {
                            handleClose();
                            actions.logout();
                        }, children: _jsx(Box, { sx: sxStyles.listItemLabel, children: _jsxs(Stack, { direction: "row", alignItems: "center", children: ["Logout ", _jsx(LogoutIcon, { sx: sxStyles.logoutIcon })] }) }) })] }))] }));
};
export default AvatarSlot;
//# sourceMappingURL=AvatarSlot.js.map